import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
/**
 * @param {string} title - Title is string parameter.
 */
const NavBarTitle = ({ title, titleIcon, style }) => {
  const theme = useTheme();
  return (
    <Stack
      direction='row'
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0.5em',
      }}
    >
      {titleIcon}
      <Typography
        variant='body1'
        sx={{ color: theme.palette.secondary.contrastText, ...style?.title }}
      >
        {title}
      </Typography>
    </Stack>
  );
};

export default NavBarTitle;
